import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ViewName = 'notes' | 'summary' | 'timeline' | 'gameplan';

const TicketDetailUISlice = createSlice({
    name: 'ticketDetailsUI',
    initialState: {
        viewName: 'notes' as ViewName,
        status: 'idle',
        error: null,
        menuExpanded: false,
        actionExpanded: 0,
        flaggedNotes: {
            hasNotes: false,
            expanded: false
        }
    },
    reducers: {
        setFlaggedNotesExpanded: (state, action: PayloadAction<boolean>) => {
            state.flaggedNotes.expanded = action.payload;
        },
        setFlaggedNotesExist: (state, action: PayloadAction<boolean>) => {
            state.flaggedNotes.hasNotes = action.payload;
        },
        setMenuExpanded: (state, action: PayloadAction<boolean>) => {
            state.menuExpanded = action.payload;
        },
        setView: (state, action: PayloadAction<ViewName>) => {
            state.viewName = action.payload;
        },
        setActionExpanded: (state, action: PayloadAction<number>) => {
            state.actionExpanded = action.payload;
            if (state.viewName !== 'notes') {
                state.viewName = 'notes';
            }
        }
    },
});

export const { setView, setMenuExpanded, setActionExpanded, setFlaggedNotesExpanded, setFlaggedNotesExist } = TicketDetailUISlice.actions;
export default TicketDetailUISlice.reducer;